"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.epic = exports.getToken = void 0;
exports.downloadLink = downloadLink;
var redux_observable_1 = require("redux-observable");
var ajax_1 = require("rxjs/ajax");
var helpers_1 = require("../utils/helpers");
var allEpics_1 = require("./allEpics");
var storage = new helpers_1.AsyncStorage({
    storageBackend: window.localStorage
});
function downloadLink(document) {
    return function (url) {
        var link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
}
var getToken = function (store) { return function () {
    return "Bearer ".concat(store.value.auth.current.token);
}; };
exports.getToken = getToken;
var handleAjax = function (params) {
    if (typeof params === 'object' && !params.allowCache) {
        params.headers = __assign({ 'Cache-Control': 'no-cache', Pragma: 'no-cache' }, (params.headers || {}));
    }
    return (0, ajax_1.ajax)(params);
};
var epic = function (action$, state$) {
    return redux_observable_1.combineEpics.apply(void 0, allEpics_1.allEpics)(action$, state$, {
        ajax: handleAjax,
        storage: storage,
        getToken: (0, exports.getToken)(state$),
        baseUrl: __APIBASEURL__,
        frontUrl: '/',
        uploadServerUrl: __UPLOADSERVERURL__,
        downloadLink: downloadLink(document)
    });
};
exports.epic = epic;
exports.default = exports.epic;
